<template>
  <div data-component-group="contract-form" data-component="tracking">
    <slot name="beforeForm" />

    <UriForm
      :uri="domain"
      :is-disabled="isDisabled"
      :is-single-line="true"
      :is-loading="isLoading"
      :label="$t('domain_or_url')"
      :confirm-trigger-label="$t('set_tracking')"
      :on-submit="onSubmit"
    />

    <div v-if="hasItem" class="domain-box">
      <div class="domain-box-tile">
        <div class="domain-box-item">
          <labels-amount
            :label="$t('domain')"
            size="sm"
            :value="currentDomain.url"
          />
        </div>
        <div v-if="hasKeywords" class="domain-box-item">
          <labels-amount
            :label="$t('keywords')"
            :value="getFormatedKeywords(currentDomain.keywords)"
          />
        </div>
        <div v-if="currentDomain.seller_id" class="domain-box-item">
          <labels-amount
            :label="$t('seller_id')"
            :value="currentDomain.seller_id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UriForm from '../uri/AddNew';
  import { isArr, isObj } from '../../../utils';

  export default {
    components: {
      UriForm,
    },
    props: {
      domain: {
        type: Object,
        default: undefined,
      },
      triggerLabel: {
        type: String,
        default: 'Update',
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      onSubmit: {
        type: Function,
        default: () => {},
      },
    },
    computed: {
      activeContract() {
        return this.$store.getters['contracts/activeItem'];
      },
      currentDomain() {
        return this.activeContract.domain;
      },
      hasItem() {
        return isObj(this.currentDomain);
      },
      hasKeywords() {
        return (
          isArr(this.currentDomain.keywords) &&
          this.currentDomain.keywords.length !== 0
        );
      },
    },
    methods: {
      getFormatedKeywords(arr) {
        return isArr(arr) ? arr.join(', ') : '';
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='contract-form'][data-component='tracking'] {
  padding: $spacing-xl;
  background-color: map.get($colors, shades, 'white');
  border-top: 1px solid map.get($colors, grey, lighten-2);

  [data-component='add-new'] {
    box-shadow: none !important;
    padding: 0;
  }

  > .component-actions {
    padding: 9px 0 0 0;
    text-align: right;

    .v-btn {
      margin-top: 0;
      margin-bottom: 0;

      .v-icon {
        margin: 0 6px 0 0;
      }
    }
  }

  .domain-box {
    padding: 16px 0 0 0;
    border-radius: $border-radius;

    .domain-box-tile {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 8px 16px;
      border-radius: $border-radius;
      background-color: #eee;

      .domain-box-item {
        display: flex;
        align-items: flex-start;

        .item-label {
          min-width: 80px;
        }
        
        .item-value {
          font-size: 1rem;
        }
      }
    }
  }
}
</style>
